$(document).ready(function () {
  //Footer Accordian
  $(function () {
    const $headers = $('.footer-menu .footer-menu-heading');

    $headers.click(function () {
      const $this = $(this);
      $headers.not($this).removeClass('active');
      $this.toggleClass('active');
    });
  });

  // Mega Menu Desktop
  // Main menu hover
  $('.main-list-menu .list-menu-item').hover(
    function () {
      $(this).addClass('active-menu');
      $('body')
        .addClass('menu-main')

    },
    function () {
      $(this).removeClass('active-menu');
      $('body')
        .removeClass('menu-main')
    }
  );

  // Product Mega Menu 
  // const $slider = $('.product-slider');

  // if ($slider.children().length > 1) {
  //   $slider.slick({
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     touchThreshold: 10,
  //     infinite: true,
  //     speed: 300,
  //     lazyLoad: 'ondemand',
  //     arrows: false,
  //     responsive: [
  //       {
  //         breakpoint: 1200,
  //         settings: {
  //           slidesToShow: 3
  //         }
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           slidesToShow: 2,
  //           infinite: false
  //         }
  //       }
  //     ]
  //   });
  // }
  initMobSlider()
});

function initMobSlider() {
  const $slider = $('.mobile-product-slider');

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      touchThreshold: 10,
      adaptiveHeight: false,
      infinite: false,
      speed: 300,
      arrows: false,
      dots: true,
    });
  }
}

function rebuyProductHasCustomTag(product) {
  if (!product) return false;

  const tagFields = [
    product.tags,
    product.product_tags,
    product.shopify_tags,
    product.shopify_product_tags,
  ];

  return tagFields.some((tags) => {
    if (!tags) return false;

    if (Array.isArray(tags)) {
      return tags.some((tag) => tag === 'Custom Product' || tag === 'custom-product');
    }

    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map((tag) => tag.trim())
        .some((tag) => tag === 'Custom Product' || tag === 'custom-product');
    }

    return false;
  });
}

function filterRebuyCustomProducts(event) {
  if (window.localThreadsCustomer?.isB2B) return;

  const widget = event?.detail?.widget;
  const eventProducts = event?.detail?.products;
  const widgetProducts = widget?.data?.products;
  const products = Array.isArray(eventProducts) ? eventProducts : widgetProducts;

  if (!Array.isArray(products)) return;

  const filteredProducts = products.filter((product) => !rebuyProductHasCustomTag(product));
  if (filteredProducts.length === products.length) return;

  products.splice(0, products.length, ...filteredProducts);

  if (Array.isArray(widgetProducts) && widgetProducts !== products) {
    widgetProducts.splice(0, widgetProducts.length, ...filteredProducts);
  }

  if (widget?.data && !Array.isArray(widget.data.products)) {
    widget.data.products = filteredProducts;
  }

  if (filteredProducts.length === 0) {
    widget?.el?.closest('.rebuy_product_block, .related-products')?.classList.add('hidden');
  }
}

['rebuy.ready', 'rebuy.beforeShow', 'rebuy.beforeProductsChange', 'rebuy.productsChange'].forEach((eventName) => {
  document.addEventListener(eventName, filterRebuyCustomProducts);
});

function getRebuyProductValue(product, keys) {
  if (!product) return '';

  for (const key of keys) {
    const value = product[key];
    if (value !== undefined && value !== null && value !== '') return String(value);
  }

  return '';
}

const rebuyB2BRetailProducts = [];

function normalizeRebuyText(value) {
  return String(value || '').trim().toLowerCase();
}

function rememberRebuyB2BRetailProducts(products) {
  if (!window.localThreadsCustomer?.isB2B || !Array.isArray(products)) return;

  products.forEach((product) => {
    if (rebuyProductHasCustomTag(product)) return;

    const productId = getRebuyProductValue(product, ['id', 'product_id', 'shopify_product_id']);
    const productHandle = getRebuyProductValue(product, ['handle', 'product_handle']);
    const productTitle = getRebuyProductValue(product, ['title', 'product_title', 'name']);
    const key = [productId, productHandle, productTitle].filter(Boolean).join('|');

    if (!key) return;

    const isStored = rebuyB2BRetailProducts.some((storedProduct) => storedProduct.key === key);
    if (isStored) return;

    rebuyB2BRetailProducts.push({
      key,
      id: productId,
      handle: normalizeRebuyText(productHandle),
      title: normalizeRebuyText(productTitle),
    });
  });
}

function findRebuyProductBlock(widget, product, index) {
  const widgetElement = widget?.el || widget?.element;
  if (!widgetElement) return null;

  const productId = getRebuyProductValue(product, ['id', 'product_id', 'shopify_product_id']);
  const productHandle = getRebuyProductValue(product, ['handle', 'product_handle']);
  const selectors = [];

  if (productId) {
    selectors.push(
      `[data-product-id="${productId}"]`,
      `[data-product_id="${productId}"]`,
      `[data-id="${productId}"]`
    );
  }

  if (productHandle) {
    selectors.push(
      `[data-handle="${productHandle}"]`,
      `[data-product-handle="${productHandle}"]`
    );
  }

  for (const selector of selectors) {
    const match = widgetElement.querySelector(selector);
    const block = match?.closest('.rebuy-product-block, .rebuy-product, [class*="rebuy-product"], li');
    if (block) return block;
  }

  return widgetElement.querySelectorAll('.rebuy-product-block')[index] || null;
}

function isRebuyAddButton(button) {
  if (!button?.classList?.contains('rebuy-button')) return false;
  if (button.classList.contains('outline') || button.classList.contains('product-quick-view-button')) return false;

  const ariaLabel = button.getAttribute('aria-label') || '';
  const buttonText = button.textContent || '';

  return /add/i.test(`${ariaLabel} ${buttonText}`) && /cart/i.test(ariaLabel);
}

function disableRebuyButton(button) {
  if (!button || button.classList.contains('rebuy-button--b2b-retail-disabled')) return;

  button.classList.add('rebuy-button--b2b-retail-disabled');
  button.setAttribute('aria-disabled', 'true');
  button.setAttribute('aria-label', 'Please log out to purchase');
  button.setAttribute('tabindex', '-1');
  button.textContent = 'Please log out to purchase';

  if ('disabled' in button) {
    button.disabled = true;
  }

  if (button.hasAttribute('href')) {
    button.dataset.originalHref = button.getAttribute('href');
    button.removeAttribute('href');
  }
}

function disableRebuyProductAddButton(block, product, widgetElement) {
  const buttons = new Set();

  if (block) {
    block.classList.add('rebuy-product-block--b2b-retail-disabled');
    block.querySelectorAll('.rebuy-button').forEach((button) => buttons.add(button));
  }

  const productTitle = normalizeRebuyText(getRebuyProductValue(product, ['title', 'product_title', 'name']));
  if (widgetElement && productTitle) {
    widgetElement.querySelectorAll('.rebuy-button[aria-label]').forEach((button) => {
      if (normalizeRebuyText(button.getAttribute('aria-label')).includes(productTitle)) {
        buttons.add(button);
      }
    });
  }

  buttons.forEach((button) => {
    if (isRebuyAddButton(button)) {
      disableRebuyButton(button);
    }
  });
}

function disableKnownRebuyButtonsFromDom(root = document) {
  if (!window.localThreadsCustomer?.isB2B) return;

  if (root.matches?.('.rebuy-button[aria-label]') && isRebuyAddButton(root)) {
    disableRebuyButton(root);
  }

  root.querySelectorAll('.rebuy-button[aria-label]').forEach((button) => {
    if (!isRebuyAddButton(button)) return;

    const ariaLabel = normalizeRebuyText(button.getAttribute('aria-label'));
    const isKnownRetailProduct = rebuyB2BRetailProducts.some((product) => (
      (product.title && ariaLabel.includes(product.title))
      || (product.handle && ariaLabel.includes(product.handle))
      || (product.id && ariaLabel.includes(product.id))
    ));

    if (isKnownRetailProduct || rebuyB2BRetailProducts.length === 0) {
      disableRebuyButton(button);
    }
  });
}

function disableRebuyB2BRetailProducts(event) {
  if (!window.localThreadsCustomer?.isB2B) return;

  const widget = event?.detail?.widget;
  const products = event?.detail?.products || widget?.data?.products;
  if (!widget || !Array.isArray(products)) return;

  const widgetElement = widget?.el || widget?.element;
  rememberRebuyB2BRetailProducts(products);

  products.forEach((product, index) => {
    if (rebuyProductHasCustomTag(product)) return;

    disableRebuyProductAddButton(findRebuyProductBlock(widget, product, index), product, widgetElement);
  });

  disableKnownRebuyButtonsFromDom(widgetElement || document);
}

['rebuy.ready', 'rebuy.beforeShow', 'rebuy.productsChange'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    disableRebuyB2BRetailProducts(event);
    setTimeout(() => disableRebuyB2BRetailProducts(event), 100);
  });
});

document.addEventListener(
  'click',
  function (event) {
    if (!event.target.closest('.rebuy-button--b2b-retail-disabled')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

if (window.localThreadsCustomer?.isB2B) {
  document.addEventListener('DOMContentLoaded', () => {
    disableKnownRebuyButtonsFromDom();
  });

  const rebuyButtonObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          disableKnownRebuyButtonsFromDom(node);
        }
      });
    });
  });

  rebuyButtonObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}


// Rebuy Widget Add to cart JS

document.addEventListener('rebuy:cart.add', function () {

  /* =========================================
     UPDATE CART DRAWER (FULL REFRESH)
  ========================================== */

  fetch(`${routes.cart_url}?sections=cart-drawer&t=${Date.now()}`)
    .then((response) => response.json())
    .then((data) => {

      const parser = new DOMParser();
      const newHTML = parser.parseFromString(data['cart-drawer'], 'text/html');

      // Replace entire drawer inner content (header + items + footer)
      const currentInner = document.querySelector('cart-drawer .drawer__inner');
      const newInner = newHTML.querySelector('cart-drawer .drawer__inner');

      if (currentInner && newInner) {
        currentInner.replaceWith(newInner);
      }

      // Remove empty state if exists
      document.querySelector('.drawer__inner-empty')?.remove();

      // Open drawer (Dawn native method safe)
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');

        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.setAttribute('open', '');
        }
      }

    })
    .catch((error) => {
      console.error('Drawer update failed:', error);
    });


  /* =========================================
     UPDATE HEADER CART BUBBLE
  ========================================== */

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const count = cart.item_count;
      const icon = document.querySelector('#cart-icon-bubble');
      if (!icon) return;

      let bubble = icon.querySelector('.cart-count-bubble');

      if (count > 0) {

        if (!bubble) {
          icon.insertAdjacentHTML('beforeend', `
            <div class="cart-count-bubble">
              <span aria-hidden="true">${count}</span>
              <span class="visually-hidden">${count} items</span>
            </div>
          `);
        } else {
          const visible = bubble.querySelector('span[aria-hidden="true"]');
          const hidden = bubble.querySelector('.visually-hidden');

          if (visible) visible.textContent = count;
          if (hidden) hidden.textContent = `${count} items`;
        }

      } else {
        bubble?.remove();
      }

    })
    .catch((error) => {
      console.error('Cart bubble update failed:', error);
    });

});

document.addEventListener('DOMContentLoaded', function () {
	// Function to reinitialize Rebuy
	function reinitializeRebuy() {
		if (typeof Rebuy !== 'undefined' && Rebuy.init) {
			Rebuy.init(); // Adjust this based on Rebuy’s actual API method
		}
	}

	setInterval(() => {
		reinitializeRebuy();
	}, 1000);
});


document.addEventListener("keypress", function (e) {
  if (e.target.classList.contains("quantity__input")) {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }
});


 /* =========================================
     Wishlist Product ATC In Cart Drawer
  ========================================== */


document.addEventListener('DOMContentLoaded', function() {
    // 1. Intercept clicks on the app's button during the capturing phase
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.wishlist-hero-list-card-footer-add-to-cart');
        if (!btn) return; 

        // Block the app's default redirect behavior completely
        e.preventDefault();
        e.stopPropagation();

        let variantId = null;
        
        // Scraping the Variant ID safely out of the app's wrapper elements
        const cardRoot = btn.closest('.MuiPaper-root');
        if (cardRoot) {
            const priceUpdateEl = cardRoot.querySelector('.wishlist-hero-price-update');
            if (priceUpdateEl && priceUpdateEl.id) {
                variantId = priceUpdateEl.id.replace(/^\D+/g, ''); 
            }
        }

        if (!variantId) {
            const productLink = btn.closest('.MuiGrid-root').querySelector('a[href*="variant="]');
            if (productLink) {
                const urlParams = new URLSearchParams(productLink.href.split('?')[1]);
                variantId = urlParams.get('variant');
            }
        }

        if (!variantId) {
            console.error("Could not resolve Variant ID.");
            return;
        }

        // UI Loading Feedback
        const labelSpan = btn.querySelector('.MuiButton-label');
        const originalText = labelSpan ? labelSpan.innerText : 'Add To Cart';
        if (labelSpan) labelSpan.innerText = 'Adding...';
        btn.style.opacity = '0.7';
        btn.style.pointerEvents = 'none';

        // 2. Request BOTH the cart drawer AND header icon sections simultaneously to keep everything synced
        const formData = {
            'id': variantId,
            'quantity': 1,
            'sections': 'cart-drawer,cart-icon-bubble' 
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(responseJson => {
            // Revert button states
            if (labelSpan) labelSpan.innerText = originalText;
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';

            // 3. Hand the fresh HTML sections over to our renderer
            if (responseJson.sections) {
                renderAndOpenCart(responseJson.sections);
            } else {
                fallbackRefresh();
            }
        })
        .catch(error => {
            console.error('Error handling AJAX cart addition:', error);
            if (labelSpan) labelSpan.innerText = originalText;
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
        });
    }, true); 
});

// 4. Dom Manipulation, Header Sync & Close-Safe Drawer Trigger
function renderAndOpenCart(sections) {
    // --- FIX PART A: Bulletproof Sync for the header cart count bubble ---
    const currentHeaderBubble = document.querySelector('#cart-icon-bubble');
    if (currentHeaderBubble && sections['cart-icon-bubble']) {
        const parser = new DOMParser();
        const parsedHeader = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        
        // Safely try targeting the specific ID node, then standard template nodes, then raw string body text
        const incomingHeaderBubble = parsedHeader.querySelector('#cart-icon-bubble') || 
                                     parsedHeader.querySelector('.header__icon--cart') || 
                                     parsedHeader.body.firstElementChild || 
                                     parsedHeader.body;
        
        if (incomingHeaderBubble) {
            // If the selector pulled the outer component block instead of raw text contents, match its inner elements
            if (incomingHeaderBubble.id === 'cart-icon-bubble' || incomingHeaderBubble.tagName === 'A') {
                currentHeaderBubble.innerHTML = incomingHeaderBubble.innerHTML;
            } else {
                // Instantly inject the raw section string content directly as fallback insurance
                currentHeaderBubble.innerHTML = incomingHeaderBubble.innerHTML || sections['cart-icon-bubble'];
            }
        }
    }

    // --- FIX PART B: Update content without deleting native close events ---
    const drawerElement = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!drawerElement) return;

    if (sections['cart-drawer']) {
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(sections['cart-drawer'], 'text/html');
        
        // Target the inner wrapper element containing the line items (leaving parent close buttons un-wiped)
        const currentInner = drawerElement.querySelector('.drawer__inner, .cart-drawer__inner') || drawerElement;
        const incomingInner = parsedHtml.querySelector('.drawer__inner, .cart-drawer__inner') || parsedHtml.querySelector('cart-drawer, #CartDrawer, .cart-drawer');

        if (currentInner && incomingInner) {
            currentInner.innerHTML = incomingInner.innerHTML;
        }

        // Strip out empty states
        drawerElement.classList.remove('is-empty');
        const wrapperEl = drawerElement.querySelector('.drawer__inner-empty, .cart-drawer__empty');
        if (wrapperEl) wrapperEl.style.display = 'none';
    }

    // --- FIX PART C: Safely trigger the drawer using native custom element API ---
    if (typeof drawerElement.open === 'function') {
        drawerElement.open(); // Native Dawn theme drawer opener (keeps close listeners 100% functional)
    } else {
        drawerElement.classList.add('active', 'is-open', 'open');
        document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    }

    // Broadcast update event across global theme files to force any lingering scripts to sync instantly
    document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { status: true }
    }));
}

// Emergency Fallback if section object execution fails completely
function fallbackRefresh() {
    fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
        .then(res => res.json())
        .then(json => {
            if (json) renderAndOpenCart(json);
        });
}